
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import * as SSApi from '@/api/SchoolSettingsApi'
import { ensureValueIsDate } from '@/services/DateHelpers'
import { IdName } from '@ViewModels/IdName'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { SubscriptionAdminViewModel } from '@ViewModels/SubscriptionAdminViewModel'
import { PartySubscriptionUpdateDto } from '@ViewModels/PartySubscriptionUpdateDto'
import { Alert, ClickToSelectList } from '@/components'
import { SaveButton, StandardButton } from '@/components/buttons'
import { Checkbox, DatePicker, TextDisplay, DateDisplay, DropDownSelect } from '@/components/formGroups'

export default Vue.extend({
   name: 'UserSubscription',
   props: {
      schoolId: String,
      editingItem: Object as () => PartyIdentityUserDto,
      editingSubscription: Object as () => SubscriptionAdminViewModel,
   },
   data() {
      return {
         subscription: {} as PartySubscriptionUpdateDto,
         schoolteacherOptions: [] as NameValuePair[],
         processing: false,
         processed: false,
      }
   },
   computed: {
      subscriptionLevelOptions(): NameValuePair[] {
         return this.$store.getters.subscriptionOptions
         .map((opt: IdName) => ({
            name: opt.Name,
            value: opt.Id.toLowerCase(),
         }))
         .sort((o1 :NameValuePair, o2: NameValuePair) => +o1.name - +o2.name)
         
      },
   },
   mounted() {
      this.loadSchoolTeacherOptions()
   },
   watch: {
      editingSubscription: {
         immediate: true,
         deep: true,
         handler(value) {
            if (value) {
               this.subscription = {
                  Id: value.Id,
                  SubscriptionAutomaticallyRenews: value.SubscriptionAutomaticallyRenews,
                  SubscriptionExpiry: ensureValueIsDate(value.SubscriptionExpiry),
                  SubscriptionLevelId: value.SubscriptionLevelId,
                  PartyIds: value.PartyIds,
               } as PartySubscriptionUpdateDto
            }
         },
      },
   },
   methods: {
      async loadSchoolTeacherOptions() {
         let schoolId: string | null | undefined = this.schoolId
         if (!schoolId) {
            schoolId = this.editingSubscription.SchoolId
         }
         if (schoolId) {
            this.schoolteacherOptions = await SSApi.getSchoolTeacherPartyOptions(schoolId)
         }
      },
      async action() {
         this.processing = true
         try {
            await Api.updatePartySubscription(this.subscription)
            this.processed = true
            this.processing = false
            this.$emit('saved')
         } catch {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
      StandardButton,
      DatePicker,
      Checkbox,
      TextDisplay,
      DateDisplay,
      ClickToSelectList,
      DropDownSelect
   },
})
